import privacyPolicyContent from "../PrivacyAssests/PrivacyPolicy.js"
import MetaTags from "../components/SEO/MetaTags";
import { pageConfigs } from "../utils/seo";

const PrivacyPolicy = () => {
  return (
    <>
      <MetaTags
        title={pageConfigs.privacyPolicy.title}
        description={pageConfigs.privacyPolicy.description}
        keywords={pageConfigs.privacyPolicy.keywords}
        canonical={pageConfigs.privacyPolicy.canonical}
        noindex={pageConfigs.privacyPolicy.noindex}
      />
      <div className="bg-gray-100 min-h-screen p-5 flex justify-center">
      <div className="bg-gray-900 shadow-lg rounded-lg p-6 w-full max-w-5xl lg:max-w-6xl xl:max-w-7xl">
        <h1 className="text-white text-3xl font-bold mb-6 text-center">PRIVACY POLICY</h1>
        <div dangerouslySetInnerHTML={{ __html: privacyPolicyContent }} />
      </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;

